import React, { useState, useEffect } from 'react';
import { fetchPurchaseReturns, savePurchaseReturn, deletePurchaseReturn, fetchProducts } from '../../services/api';

const initialReturns = [
  { id: 1, date: '04-12-2025', returnNo: 'PR-0008', origPO: 'PO-0842', supplier: 'HPCL Depot', product: 'HSD', returnQty: 200, rate: 89.50, amount: 17900.00, reason: 'Quality Issue (water contamination)', status: 'Approved' },
  { id: 2, date: '02-12-2025', returnNo: 'PR-0007', origPO: 'PO-0840', supplier: 'HPCL Depot', product: 'MS', returnQty: 50, rate: 96.20, amount: 4810.00, reason: 'Short delivery adjustment', status: 'Approved' },
  { id: 3, date: '30-11-2025', returnNo: 'PR-0006', origPO: 'PO-0839', supplier: 'Lube Oil Traders', product: 'Lube', returnQty: 5, rate: 250.00, amount: 1250.00, reason: 'Damaged packaging', status: 'Pending' },
  { id: 4, date: '25-11-2025', returnNo: 'PR-0005', origPO: 'PO-0835', supplier: 'BPCL Distributor', product: 'CNG', returnQty: 100, rate: 82.00, amount: 8200.00, reason: 'Over supply', status: 'Rejected' },
];

export default function PurchaseReturn({ user }) {
  const companyId = user?.Companyid || user?.company_id || "1";

  const [returns, setReturns] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ date: getTodayForUI(), origBill: '', supplier: '', product: 'HSD', returnQty: '', rate: '', reason: '' });

  useEffect(() => {
    loadInitialData();
    loadData();
  }, [companyId]);

  function getTodayForUI() {
    const d = new Date();
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

  function formatDateForAPI(dateStr) {
    if (!dateStr || !dateStr.includes('-')) return dateStr;
    const [y, m, d] = dateStr.split('-');
    return `${d}-${m}-${y}`;
  }

  const loadInitialData = async () => {
    try {
      const prodRes = await fetchProducts(companyId);
      if (prodRes.success) setAllProducts(prodRes.Response || []);
    } catch (err) {
      console.error("Products fetch error:", err);
    }
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await fetchPurchaseReturns({ Companyid: companyId });
      if (res.success) {
        const raw = res.Response || [];
        const list = Array.isArray(raw) ? raw : [raw];
        setReturns(list.map(r => ({
          id: r.IDS || r.Recid,
          date: r.Date1 || r.date,
          returnNo: r.ReturnNo || r.returnNo,
          origBill: r.OrigBill || r.origBill,
          supplier: r.Supplier || r.supplier || '—',
          product: r.Product || r.product,
          returnQty: parseFloat(r.Qty || r.qty || 0),
          rate: parseFloat(r.Rate || r.rate || 0),
          amount: parseFloat(r.Amount || r.amount || 0),
          reason: r.Reason || r.reason || '—'
        })));
      }
    } catch (err) {
      console.error("Purchase returns fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    if (!form.origBill || !form.returnQty) return;
    
    try {
      const payload = {
        Companyid: companyId,
        Date1: formatDateForAPI(form.date),
        OrigBill: form.origBill,
        Supplier: form.supplier,
        Product: form.product,
        Qty: form.returnQty.toString(),
        Rate: form.rate.toString(),
        Amount: (parseFloat(form.returnQty) * parseFloat(form.rate)).toString(),
        Reason: form.reason,
        IDS: "0"
      };

      const result = await savePurchaseReturn(payload);
      if (result.success || result.Response === "INSERTED") {
        await loadData();
        setShowForm(false);
        setForm({ date: getTodayForUI(), origBill: '', supplier: '', product: 'HSD', returnQty: '', rate: '', reason: '' });
      } else {
        alert(result.message || "Failed to save return");
      }
    } catch (err) {
      console.error("Save error:", err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this record?')) return;
    try {
      const result = await deletePurchaseReturn(id);
      if (result.success || result.Response === "DELETED" || result.status === "Success") {
        await loadData();
      } else {
        alert(result.message || "Failed to delete record");
      }
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  const total = returns.reduce((s, r) => s + r.amount, 0);

  return (

    <div className="pump-page">

      <div className="page-header">

        <h2 className="page-title">Purchase Return</h2>

        <div style={{ display: 'flex', gap: 8 }}>
          <button
            className="btn btn-primary btn-sm"
            onClick={() => setShowForm(!showForm)}
          >
            ＋ New Return
          </button>

          <button className="export-btn">
            ⬆ Export
          </button>
        </div>

      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill,minmax(155px,1fr))',
          gap: 12,
          marginBottom: 14
        }}
      >

        {[
          { label: 'Total Returns', val: returns.length, color: 'var(--primary)' },
          { label: 'Return Value', val: '₹' + total.toLocaleString(), color: 'var(--danger)' },
        ].map(c => (

          <div
            key={c.label}
            style={{
              background: '#fff',
              border: '1px solid var(--border)',
              borderRadius: 'var(--radius)',
              padding: '12px 16px',
              boxShadow: 'var(--shadow-sm)',
              borderLeft: `4px solid ${c.color}`
            }}
          >

            <div style={{ fontSize: 20, fontWeight: 800, color: c.color }}>
              {c.val}
            </div>

            <div style={{ fontSize: 11.5, color: 'var(--text-secondary)', fontWeight: 600 }}>
              {c.label}
            </div>

          </div>

        ))}

      </div>

      {showForm && (

        <div className="section-card">

          <div className="section-header">New Purchase Return</div>

          <div className="form-row">

            <div className="form-group">
              <label>Date</label>
              <input
                type="date"
                className="form-control"
                value={form.date}
                onChange={e => setForm({ ...form, date: e.target.value })}
              />
            </div>

            <div className="form-group">
              <label>Original Bill No.</label>
              <input
                className="form-control"
                value={form.origBill}
                onChange={e => setForm({ ...form, origBill: e.target.value })}
                placeholder="Bill No."
              />
            </div>

            <div className="form-group">
              <label>Supplier</label>
              <input
                className="form-control"
                value={form.supplier}
                onChange={e => setForm({ ...form, supplier: e.target.value })}
              />
            </div>

            <div className="form-group">
              <label>Product</label>
              <select
                className="form-control"
                value={form.product}
                onChange={e => setForm({ ...form, product: e.target.value })}
              >
                {allProducts.map(p => <option key={p.Productname} value={p.Productname}>{p.Productname}</option>)}
              </select>
            </div>

            <div className="form-group">
              <label>Return Qty</label>
              <input
                type="number"
                className="form-control"
                value={form.returnQty}
                onChange={e => setForm({ ...form, returnQty: e.target.value })}
              />
            </div>

            <div className="form-group">
              <label>Rate (₹)</label>
              <input
                type="number"
                className="form-control"
                value={form.rate}
                onChange={e => setForm({ ...form, rate: e.target.value })}
              />
            </div>

            <div className="form-group">
              <label>Reason</label>
              <input
                className="form-control"
                value={form.reason}
                onChange={e => setForm({ ...form, reason: e.target.value })}
              />
            </div>

          </div>

          <div className="action-bar" style={{ padding: '0 16px 14px' }}>

            <button className="btn btn-primary" onClick={handleSave}>
              <i className="bi bi-save me-1"></i> Save
            </button>
            <button className="btn btn-secondary" onClick={() => setShowForm(false)}>
              ✕ Cancel
            </button>

          </div>

        </div>

      )}

      <div className="section-card">

        <div className="section-header">
          Purchase Return Records — ₹{total.toLocaleString()}
        </div>

        <div className="table-wrapper">

          <table className="data-table">

            <thead>
              <tr>
                <th style={{ textAlign: 'center' }}>Date</th>
                <th style={{ textAlign: 'center' }}>Return No.</th>
                <th style={{ textAlign: 'center' }}>Orig. Bill</th>
                <th style={{ textAlign: 'left' }}>Supplier</th>
                <th style={{ textAlign: 'center' }}>Product</th>
                <th style={{ textAlign: 'right' }}>Return Qty</th>
                <th style={{ textAlign: 'right' }}>Rate (₹)</th>
                <th style={{ textAlign: 'right' }}>Amount (₹)</th>
                <th style={{ textAlign: 'left' }}>Reason</th>
                <th style={{ textAlign: 'center' }}>Action</th>
              </tr>
            </thead>

            <tbody>

              {returns.map((r) => (
                <tr key={r.id}>
                  <td style={{ textAlign: 'center' }}>{r.date}</td>
                  <td style={{ textAlign: 'center', fontWeight: 700, color: 'var(--danger)', fontFamily: 'monospace' }}>
                    {r.returnNo}
                  </td>
                  <td style={{ textAlign: 'center', fontFamily: 'monospace', color: 'var(--primary)' }}>
                    {r.origBill}
                  </td>
                  <td style={{ fontWeight: 600 }}>{r.supplier}</td>
                  <td style={{ textAlign: 'center' }}>{r.product}</td>
                  <td style={{ textAlign: 'right' }}>{r.returnQty.toLocaleString()}</td>
                  <td style={{ textAlign: 'right' }}>₹{r.rate.toLocaleString()}</td>
                  <td style={{ textAlign: 'right', fontWeight: 700 }}>₹{r.amount.toLocaleString()}</td>
                  <td style={{ fontSize: 11.5, color: 'var(--text-secondary)' }}>{r.reason}</td>
                  <td className="text-center">
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>

      </div>

    </div>

  );

}